// extracted by mini-css-extract-plugin
module.exports = {"darkMode":"companies-module--dark-mode--1P7_D","root":"companies-module--root--dWPGw"};